module.exports = __webpack_public_path__ + "static/img/son6.55b72bea.png";